import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Route wrapper — requires an active or trialing subscription.
 *
 * Trust source: `user.subscription_status` on the AuthContext (set by
 * `/api/auth/me`). Admin users bypass — they're never paywalled.
 *
 * Backend also enforces this via a 402 on paywalled `/api/*` routes, so a
 * user who tampers with the client can't reach the feed data.
 */
const ACTIVE = new Set(["trialing", "active"]);

export default function RequireSubscription({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // RequireUser already handled the "checking / anon" cases before this
  // component renders, so `user` here should always be an object. Belt-and-
  // braces: if we're still checking, render nothing (blank splash).
  if (!user || user === null || user === false) return null;

  if (user.role === "admin") return children;
  if (ACTIVE.has(user.subscription_status)) return children;

  return (
    <Navigate
      to="/paywall"
      replace
      state={{ from: location.pathname }}
    />
  );
}
